import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Form } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
// import Lottie from 'lottie-react-web';
// import animation from '../../assets/json/clean.json';
import 'react-toastify/dist/ReactToastify.css';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import qs from 'qs';
import * as moment from "moment-timezone";
import Login from '../common/login';
const columns = [

    { field: "count", name: "العدد ", options: { filter: true, sort: true, } },
    { field: "name", name: "اسم المنتج", options: { filter: true, sort: true, } },
    { field: "id", name: "#", options: { width: 200, filter: true, sort: false, } },
];
const options = {
    selectableRows: false,
    responsive: 'scroll',
    rowCursorHand: false,
    sort: true,
    print: false,
    filter: false,
    download: false,
    onSearchChange: (e) => {
        console.log(e);
    },
    textLabels: {
        body: {
            noMatch: " لم يتم العثور على سجلات مطابقة",
            toolTip: "فرز",
        },
        pagination: {
            next: "الصفحة التالية",
            previous: "الصفحة السابقة",
            rowsPerPage: "عدد الصفوف",
            displayRows: "من",
        },
        toolbar: {
            search: "بحث",
            downloadCsv: "تنزيل",
            print: "Print",
            viewColumns: " التحكم بالاعمدة",
            filterTable: "فلتر",
        },
        filter: {
            all: "الكل",
            title: "فلتر",
            reset: "إعادة تعيين",
        },
        viewColumns: {
            title: "عرض الأعمدة",
            titleAria: "إظهار / إخفاء أعمدة الجدول",
        },

    }
}
const cookies = new Cookies();

class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            pages: [],
            page: 'كل الصفحات',
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,

        }
    }
    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    //   backgroundColor: "#FF0000",
                    textAlign: 'right',
                },

            },
            MuiTableCell: {
                root: {
                    textAlign: 'right',

                },
                head: {
                    // backgroundColor: "#FF0000",
                }
            },

        }
    })

    componentDidMount(value) {
        let id;
        if (!value) {
            id = "All"
        } else {
            id = value
        }
        var header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.get(host + `users/printed/orders/watting/reports?page=${id}&status=-1`, { headers: header })
            .then(res => {
                let arr = [];
                let items = res.data.data.items


                for (let i = 0; i < items.length; i++) {
                    let obj = {
                        id: i,
                        name: items[i].components_name,
                        count: items[i].count,

                    };
                    arr.push(obj);
                }
                this.setState({
                    orders: arr, spin: false,
                    total_items: res.data.data.items_sum,
                    total_orders: res.data.data.orders_count,
                    items_cost: res.data.data.items_cost,
                    orders_cost: res.data.data.sells,
                });
            })
            .catch(error => {
                console.log(error.response)
            });
        axios.get(host + `users/pages/name/all`, { headers: header })
            .then(res => {

                this.setState({

                    pages: res.data.data.pages,
                });
            })
            .catch(error => {
                console.log(error.response)
            });
    }
    handleChangeFrom = date => {
        console.log(date);

        this.setState({
            from: date
        });
    };
    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };
    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        // if (this.state.spin) {
                        return (
                            <div >
                                <div id='ContinerReportDatePages'>
                                    <Row id='RowReportDate'>
                                        <Col id='ColReportDate' sm={12} md={4}>
                                            <span>الصفحة : &nbsp;</span>

                                            <select className="selectPages" id="selectPage" >
                                                <option value={'All'}>كل الصفحات</option>
                                                {this.state.pages.map((item, i) =>
                                                    <option value={item.id}>{item.name}</option>

                                                )}

                                            </select >
                                        </Col>
                                        <Col id='ColReportDate' sm={12} md={4}>
                                            <div id='AddClientDeptBTN' onClick={() => {
                                                let select = document.getElementById('selectPage')
                                                this.setState({ page: select.options[select.selectedIndex].text })
                                                this.componentDidMount(select.value)
                                                // console.log(value);
                                            }}>بحث</div>
                                        </Col>
                                    </Row>
                                </div>
                                <div id='ContinerReportPageName'>
                                    <Row id='RowReportDate'>
                                        <Col id='ColReportDate' >
                                            <center>  <b><h2>الصفحة : &nbsp; {this.state.page}</h2></b></center>


                                        </Col>

                                    </Row>
                                </div>
                                <div>
                                    <div className='DataTableContiner'>
                                        <MuiThemeProvider
                                            theme={this.getMuiTheme()}>
                                            <MaterialDatatable data={this.state.orders} columns={columns} options={options} />
                                        </MuiThemeProvider>
                                    </div>
                                    <div id='ContinerReportDate1'>
                                        <div id='AddClientDeptBTN1'>مجموع الطلبات</div>
                                        <div style={{ marginRight: 20 }}>{this.state.total_orders}</div>
                                    </div>
                                    <br />
                                    <div id='ContinerReportDate1'>
                                        <div id='AddClientDeptBTN12'>مجموع القطع</div>
                                        <div style={{ marginRight: 20 }}>{this.state.total_items}</div>
                                    </div>

                                    <div id='ContinerReportDate1'>
                                        <div id='AddClientDeptBTN13'>اسعار المواد</div>
                                        <div style={{ marginRight: 20 }}>{this.state.items_cost}</div>
                                    </div>

                                    <div id='ContinerReportDate1'>
                                        <div id='AddClientDeptBTN14'>مجموع المبيعات</div>
                                        <div style={{ marginRight: 20 }}>{this.state.orders_cost}</div>
                                    </div>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                        // }
                        // else {
                        //     return (
                        //         <div style={{ width: '100%', height: 'calc(100vh - 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        //             <Lottie
                        //                 options={{
                        //                     animationData: animation
                        //                 }}
                        //             />
                        //         </div>
                        //     )
                        // }
                    }
                    }
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}


export default Selles_Reports;